import React from "react";
import { Menu } from "lucide-react";
import useUser from "../hooks/useUser";
import { useSidebar } from "../hooks/useSidebar";

const DashboardHeader = () => {
  const { firstName } = useUser();
  const { toggle } = useSidebar();

  return (
    <div className="h-16 bg-white border-b border-slate-100 flex items-center justify-between px-6 lg:px-10 sticky top-0 z-20">
      <button
        onClick={toggle}
        data-testid="sidebar-toggle"
        aria-label="Toggle sidebar"
        className="p-2 rounded-lg hover:bg-slate-50 transition"
      >
        <Menu className="w-5 h-5 text-slate-700" />
      </button>

      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-[#eef4ff] text-[#1d4ed8] flex items-center justify-center font-semibold text-sm border border-[#dbe6ff]">
          {(firstName || "?").slice(0, 1).toUpperCase()}
        </div>
        <span className="text-sm font-medium text-slate-800" data-testid="header-greeting">
          Hello, {firstName}!
        </span>
      </div>
    </div>
  );
};

export default DashboardHeader;
